import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

const createFlickDirectionIndicator = (
	pointerX: MutableRefObject<number>,
	pointerY: MutableRefObject<number>,
	currentlyFlicking: MutableRefObject<boolean>,
	flickItemOriginalStartPoint: MutableRefObject<PIXI.Point>,
) => {
	const flickDirectionIndicatorContainer = new PIXI.Container();
	
	const _update = () => {
		if(currentlyFlicking.current) {
			//console.log('update flickDirectionIndicator');
    	const deltaX = pointerX.current - flickItemOriginalStartPoint.current.x;
			const deltaY = pointerY.current - flickItemOriginalStartPoint.current.y;
			const distance = Math.sqrt(deltaX**2+deltaY**2);
			let directionLine = new PIXI.Graphics();
			let directionArrow = new PIXI.Graphics();
			directionArrow.beginFill(0xdedede);
			directionLine.lineStyle({
				width: distance/50,
				color: 0xdedede,
			});
			directionLine.moveTo(flickItemOriginalStartPoint.current.x, flickItemOriginalStartPoint.current.y);
			directionLine.lineTo(pointerX.current, pointerY.current);
			directionArrow.drawShape( new PIXI.Polygon(
				pointerX.current,
				pointerY.current-(distance/25),
				pointerX.current+((distance/25)*2),
				pointerY.current,
				pointerX.current,
				pointerY.current+(distance/25)
			));
			directionArrow.pivot = new PIXI.Point(pointerX.current, pointerY.current);
			directionArrow.rotation = Math.atan2(deltaY, deltaX);
			directionArrow.x = pointerX.current;
			directionArrow.y = pointerY.current;
			flickDirectionIndicatorContainer.removeChildren();
			flickDirectionIndicatorContainer.addChild(directionLine);
			flickDirectionIndicatorContainer.addChild(directionArrow);
			_setVisible(true);
		} else {
			_setVisible(false);
		}
	}
	
	const _setVisible = (visiblityState: boolean) => {
		flickDirectionIndicatorContainer.visible = visiblityState;
	}

	return {
		container: flickDirectionIndicatorContainer,
		update: _update,
		setVisible: _setVisible,
	};
};

export default createFlickDirectionIndicator;
